module.exports = __webpack_public_path__ + "img/IMG_0204-15_L_Foamcore_MockedUp.018cf63c.jpg";